exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-header[data-v-5635bef7]{background-color:#fbfbfb}.setting-body[data-v-5635bef7]{background-color:#fdfdfd}.gravatar-pic[data-v-5635bef7]{border-radius:50%;width:100px;display:initial;margin-bottom:6px}", ""]);

// exports
